var React = require('react');

function Handcursor (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#3E424E","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M13 7.857v-4.75c0-.996-.68-1.92-1.664-2.08C10.083.824 9 1.785 9 3v13l-3.944-2.366c-.645-.387-1.455-.368-2.08.05-1.023.68-1.166 2.126-.297 2.995L8.999 23h12l1.57-10.203c.242-1.57-.782-3.057-2.336-3.39L13 7.857z"}));
}

Handcursor.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Handcursor;

Handcursor.default = Handcursor;
